import React from 'react';
import Link from '../../../shared/Link/Link';
import { jsx, css } from '@emotion/core';

import { primary_light, primary_s5_l90 } from '../../../shared/lib/colors';

import Arrow from '../../../shared/Icons/Arrow';

import './AdviceBox.scss';
import { ga4SelectPromotion } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxSelectPromotion } from '../../../shared/lib/farmakomMetrics';

const renderTags = (
  tags,
  hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics,
  hasGoogleTagManager
) => {
  const onClick = tag => {
    if (hasGoogleAnalytics4Advanced) {
      // GA4 SELECT PROMOTION
      ga4SelectPromotion(tag);
    }
    if (hasFarmakomMetrics) {
      // FKMX SELECT PROMOTION
      fkmxSelectPromotion(tag);
    }
  };

  return tags.map(tag => (
    <li key={tag.id}>
      <Link to={`/tag/${tag.seoName}`} onClick={() => onClick(tag)}>
        {tag.name} <Arrow />
      </Link>
    </li>
  ));
};

const AdviceBox = ({
  tags,
  adviceTitle,
  primaryColor,
  uiVariantSlider,
  withThumbnails = false,
  hasGoogleAnalytics4Advanced,
  hasGoogleTagManager,
  hasFarmakomMetrics,
}) => {
  const adviceBoxStyle = css`
    &.variant-1 {
      @media (min-width: 992px) {
        padding: 12px 15px;
        background-color: #fff;
        border-radius: 12px;
      }

      @media (min-width: 1200px) {
        padding: 18px 15px;
      }

      .title {
        margin: 0 0 15px 15px;
        color: ${primaryColor};
        font-size: 18px;
      }

      li {
        margin-right: 5px;
      }

      a {
        padding: 7px 7px 7px 15px;
        color: #4f4f4f;
        background-color: transparent;
        font-size: 13px;
        border-radius: 12px;

        &:focus,
        &:hover {
          color: #4f4f4f;
          background-color: ${primary_light(primaryColor)};
        }

        svg {
          color: ${primaryColor};
        }
      }

      .scrolling-section {
        height: 236px;

        @media (min-width: 1200px) {
          height: 275px;
        }

        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar {
          background-color: ${primary_light(primaryColor)};
          border-radius: 12px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: ${primaryColor};
          border-radius: 12px;
        }

        &.with-thumbnails {
          height: 356px;

          @media (min-width: 1200px) {
            height: 396px;
          }
        }
      }
    }

    &.variant-2 {
      .title {
        margin: 0 0 11px 15px;
        font-size: 16px;
      }

      li {
        border-bottom: 1px solid ${primary_s5_l90(primaryColor)};
      }

      a {
        padding: 15px;
        color: #4f4f4f;
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;

        &:focus,
        &:hover {
          color: #fff;
          background-color: ${primaryColor};
        }
      }

      .scrolling-section {
        height: 260px;

        @media (min-width: 1200px) {
          height: 311px;
        }

        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar {
          background-color: ${primary_light(primaryColor)};
        }

        &::-webkit-scrollbar-thumb {
          background-color: ${primaryColor};
        }
      }
    }

    &.variant-3 {
      @media (min-width: 992px) {
        padding: 12px 0;
        color: #fff;
        background-color: ${primaryColor};
      }

      @media (min-width: 1200px) {
        padding: 18px 0;
      }

      .title {
        margin: 0 0 15px 15px;
        font-size: 16px;
      }

      a {
        padding: 7px 15px;
        color: #fff;
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;

        &:focus,
        &:hover {
          color: ${primaryColor};
          background-color: #fff;
        }
      }

      .scrolling-section {
        height: 236px;

        @media (min-width: 1200px) {
          height: 276px;
        }

        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar {
          background-color: ${primaryColor};
        }

        &::-webkit-scrollbar-thumb {
          background-color: #fff;
        }
      }
    }
  `;

  return (
    <div
      className={`advice-box variant-${uiVariantSlider}`}
      css={adviceBoxStyle}
    >
      <div
        className={`scrolling-section ${
          withThumbnails ? 'with-thumbnails' : ''
        }`}
      >
        {adviceTitle && <div className="title">{adviceTitle}</div>}
        <ul>
          {renderTags(
            tags,
            hasGoogleAnalytics4Advanced,
            hasFarmakomMetrics,
            hasGoogleTagManager
          )}
        </ul>
      </div>
    </div>
  );
};

export default AdviceBox;
